import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de salaire quotidien - Calculer le salaire quotidien du salaire mensuel";
const DESCRIPTION =
  "Calculatrice de salaire quotidien - Calculer le salaire quotidien du salaire mensuel. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "salaire quotidien salaire quotidien salaire mensuel, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/daily-salary-calculator/";
function DailySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [workDaysPerMonth, setWorkDaysPerMonth] = useState("0");
  const [dailyRate, setDailyRate] = useState(null);
  const [error, setError] = useState("");

  const calculateDailyRate = () => {
    try {
      if (monthlySalary === "0" && workDaysPerMonth === "0") {
        setError("Veuillez entrer un salaire et un nombre de jours de travail valides pour calculer le salaire quotidien");
        return;
      }
      const dailyWage = monthlySalary / workDaysPerMonth;
      setDailyRate(dailyWage);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice offre un moyen facile de connaître le salaire que vous gagnez 
                  par jour en fonction de votre salaire mensuel et du nombre de jours de travail 
                  par mois. Connaître votre salaire quotidien est important pour comprendre la 
                  valeur de votre journée de travail, que vous pensiez à négocier votre salaire 
                  ou à planifier du travail supplémentaire. Cette calculatrice est utile pour les 
                  personnes qui travaillent à salaire mensuel et qui veulent savoir comment leurs 
                  revenus se répartissent sur les jours de travail du mois.
                </p>
                <p>
                  Par exemple, si vous gagnez un salaire mensuel de 6000 et travaillez 22 jours 
                  par mois, vous pouvez utiliser cette calculatrice pour déterminer combien vous 
                  gagnez par jour. Connaître ces détails peut vous aider à prendre des décisions 
                  financières plus sages et à négocier de meilleurs salaires en fonction de la 
                  valeur réelle de votre temps.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="salary" style={{marginRight: "10px"}}>Salaire mensuel:</label>
                    <input
                      id="salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="work-days" style={{marginRight: "10px"}}>Nombre de jours de travail par mois:</label>
                    <input
                      id="work-days"
                      type="number"
                      value={workDaysPerMonth}
                      onChange={(e) => setWorkDaysPerMonth(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginRight: "10px" }}
                    onClick={calculateDailyRate}
                  >
                    Calculer
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Erreur: {error}</p>
                ) : (
                  dailyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Salaire quotidien: {dailyRate.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Comment calculer le salaire quotidien</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 1: Déterminer le salaire mensuel
                    </h2>
                  </u>
                  <p>
                    Au début, vous devez connaître le salaire mensuel que vous gagnez. Ce 
                    salaire doit inclure tous les avantages et allocations que vous recevez 
                    chaque mois. Entrer le salaire mensuel avec précision est la première 
                    étape pour calculer correctement le salaire quotidien. Rappelez-vous que 
                    votre salaire mensuel est la base sur laquelle vous construirez les calculs 
                    suivants.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 2: Déterminer le nombre de jours de travail par mois
                    </h2>
                  </u>
                  <p>
                    Après avoir établi votre salaire mensuel, vous devez entrer le nombre de 
                    jours de travail par mois. Ce nombre représente les jours où vous travaillez 
                    au cours du mois et où vous percevez votre salaire. Le nombre de jours de 
                    travail peut varier d'un mois à l'autre, mais il est préférable d'entrer le 
                    nombre moyen de jours que vous travaillez mensuellement. Ces informations 
                    sont nécessaires pour calculer correctement le salaire quotidien.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 3: Calculer le salaire quotidien
                    </h2>
                  </u>
                  <p>
                    Après avoir entré votre salaire mensuel et le nombre de jours de travail 
                    dans le mois, vous pouvez maintenant calculer votre salaire quotidien. Pour 
                    ce faire, divisez votre salaire mensuel par le nombre de jours de travail 
                    dans le mois pour obtenir votre salaire quotidien. Cette opération mathématique 
                    vous donnera la valeur exacte du salaire que vous gagnez en une journée.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : Si votre salaire mensuel est de 6000€ et que vous travaillez 
                    22 jours par mois, votre salaire quotidien sera d'environ 272,73€.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 4: Utiliser le salaire quotidien pour la planification financière
                    </h2>
                  </u>
                  <p>
                    Une fois que vous connaissez votre salaire quotidien, vous pouvez utiliser 
                    cette information dans votre planification financière. Par exemple, si vous 
                    envisagez de travailler des jours supplémentaires ou si vous avez besoin de 
                    savoir si votre salaire quotidien suffit à couvrir vos dépenses, connaître 
                    votre salaire quotidien vous aide à prendre des décisions éclairées. Ce 
                    calcul peut également vous aider à négocier un meilleur salaire en fonction 
                    de la valeur de votre travail quotidien.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : Si vous prévoyez de travailler 5 jours supplémentaires au cours 
                    du mois, vous pouvez calculer le salaire supplémentaire que vous gagnerez 
                    en fonction de votre salaire quotidien.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DailySalaryCalculator;
